import { useMemo } from 'react';
import { Select } from 'antd';

const { OptGroup, Option } = Select;

const flattenAccounts = (accounts) => {
    const out = [];
    const walk = (arr) => {
        arr?.forEach((a) => {
             if (a.account_number) out.push(a);
            if (a.children) walk(a.children);
        });
    };
    walk(accounts);
    return out;
};

const buildAccountGroups = (accountStructure) => {
    if (!accountStructure) return [];
    return [
        { label: 'Profit & Loss', accounts: flattenAccounts(accountStructure.profitloss) },
        { label: 'Drivers', accounts: flattenAccounts(accountStructure.drivers) },
        { label: 'Balance Sheet — Assets', accounts: flattenAccounts(accountStructure.balancesheet?.assets) },
        { label: 'Balance Sheet — Liabilities', accounts: flattenAccounts(accountStructure.balancesheet?.liabilities) },
        { label: 'Balance Sheet — Equity', accounts: flattenAccounts(accountStructure.balancesheet?.equities) },
        { label: 'Cash Flow', accounts: flattenAccounts(accountStructure.cashflow) },
    ].filter((g) => g.accounts.length > 0);
};

const AccountPicker = ({
    accountStructure,
    value,
    onChange,
    placeholder = 'Search by account number or name',
    style,
    multiple = false,
}) => {
    const accountGroups = useMemo(
        () => buildAccountGroups(accountStructure),
        [accountStructure],
    );

    const accountsById = useMemo(() => {
        const map = new Map();
        accountGroups.forEach((g) => g.accounts.forEach((a) => map.set(a.account_id, a)));
        return map;
    }, [accountGroups]);

    const filterOption = (input, option) => {
        const search = input.toLowerCase();
        const accNum = (option?.['data-acc-num'] || '').toLowerCase();
        const name = (option?.['data-acc-name'] || '').toLowerCase();
        return accNum.includes(search) || name.includes(search);
    };

    return (
        <Select
            showSearch
            allowClear
            value={value}
            placeholder={placeholder}
            style={style}
            filterOption={filterOption}
            mode={multiple ? 'multiple' : undefined}
            onChange={(id) =>
                multiple
                    ? onChange((id ?? []).map((x) => accountsById.get(x)).filter(Boolean))
                    : onChange(id != null ? accountsById.get(id) : null)
            }
        >
            {accountGroups.map((group) => (
                <OptGroup key={group.label} label={group.label}>
                    {group.accounts.map((a) => (
                        <Option
                            key={a.account_id}
                            value={a.account_id}
                            data-acc-num={a.account_number}
                            data-acc-name={a.name || ''}
                        >
                            <span style={{ fontWeight: 500 }}>{a.account_number}</span>
                            {a.name && (
                                <span style={{ color: '#888', marginLeft: 8 }}>— {a.name}</span>
                            )}
                        </Option>
                    ))}
                </OptGroup>
            ))}
        </Select>
    );
};

export default AccountPicker;